<template>
    <preference-section :title="title">
        <ValidationObserver
            v-if="isBasicField"
            v-slot="{ handleSubmit }"
            class="w-full"
        >
            <form
                class="w-full flex flex-col"
                @submit.prevent="handleSubmit(save)"
                novalidate
            >
                <form-input
                    :name="field"
                    :type="inputType"
                    v-model="value"
                    class="mb-6"
                    required
                ></form-input>

                <div
                    class="flex flex-col sm:flex-row items-center justify-around"
                >
                    <btn
                        class="bg-orange rounded-large text-white px-10 mb-6 sm:mb-0"
                        >{{ $config("GUARDAR") }}</btn
                    >
                    <btn
                        class="bg-orange rounded-large text-white px-10"
                        :to="{ name: 'preferences' }"
                        >{{ $config("CANCELAR") }}</btn
                    >
                </div>
            </form>
        </ValidationObserver>

        <template v-else>
            <payment-methods-preference
                v-if="field == 'payment_methods'"
            ></payment-methods-preference>

            <promocode-preference
                v-else-if="field == 'promo_code'"
                class="w-full"
            >
            </promocode-preference>

            <btn
                class="bg-orange rounded-large text-white px-10 mt-12"
                :to="{ name: 'preferences' }"
                >{{ $config("CANCELAR") }}</btn
            >
        </template>
    </preference-section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import allowAuthenticatedOnly from "../mixins/allowAuthenticatedOnly";
import requestWithInteractions from "../mixins/requestWithInteractions";
import PreferenceSection from "../components/PreferenceSection";
import PaymentMethodsPreference from "../components/PaymentMethodsPreference";
import PromocodePreference from "../components/PromocodePreference";
import FormInput from "../components/FormInput";
import Btn from "../components/Btn";
import api from "../api";

export default {
    name: "preference",

    mixins: [allowAuthenticatedOnly, requestWithInteractions],

    components: {
        PreferenceSection,
        FormInput,
        Btn,
        PaymentMethodsPreference,
        PromocodePreference
    },

    data() {
        return {
            fields: {
                name: {
                    type: "text",
                    title: `${this.$config("CHANGE")} ${this.$config("NAME")}`
                },

                username: {
                    type: "email",
                    title: `${this.$config("CHANGE")} ${this.$config(
                        "USERNAME"
                    )}`
                },

                password: {
                    type: "password",
                    title: `${this.$config("CHANGE")} ${this.$config(
                        "PASSWORD"
                    )}`
                },

                payment_methods: {
                    title: `${this.$config("CHANGE")} ${this.$config(
                        "PAYMENT_METHOD"
                    )}`
                },

                promo_code: {
                    title: this.$config("APPLY_PROMOCODE")
                }
            },

            basicFields: ["name", "username", "password"],

            value: ""
        };
    },

    created() {
        if (!this.allowedFields.includes(this.field)) {
            this.$router.push({ name: "preferences" });
        }

        if (this.authenticatedUser[this.field]) {
            this.value = this.authenticatedUser[this.field];
        }
    },

    computed: {
        ...mapState(["authenticatedUser"]),
        ...mapGetters(["userSubscriptionIsActive", "userCanApplyPromocode"]),

        title() {
            return this.fields[this.field].title;
        },

        field() {
            return this.$route.params.field;
        },

        fieldData() {
            return this.fields[this.field];
        },

        translatedField() {
            return this.$config(this.fieldData.translationKey);
        },

        inputType() {
            return this.fieldData.type;
        },

        allowedFields() {
            let fields = this.basicFields;

            if (this.userSubscriptionIsActive) {
                fields = fields.concat("payment_methods");
            }

            if (this.userCanApplyPromocode) {
                fields = fields.concat("promo_code");
            }

            return fields;
        },

        isBasicField() {
            return this.basicFields.includes(this.field);
        }
    },

    methods: {
        save() {
            this.sendRequest(api.updateUserField(this.field, this.value), {
                beforeSendText: this.$config("SAVING_PREFERENCES"),
                successText: this.$config("YOU_DID_IT"),
                onSuccess: response => {
                    this.$store.commit(
                        "SET_AUTHENTICATED_USER",
                        response.userdata
                    );
                    this.$router.push({ name: "preferences" });
                }
            });
        }
    }
};
</script>
